import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import * as Icon from "react-feather";
import * as M from "@material-ui/core";

const UserEdit = class extends Component {
  // componentDidMount = () => {
  //   this.props.store.$user.loadUser(this.props.store.$router.key);
  // };
  componentWillUnmount = () => {
    this.props.store.$validation.clearList();
  };
  render() {
    const { $user, $router, $validation, $config } = this.props.store;

    return (
      $user.selected && (
        <form name="user-edit">
          {$user.sessionUser.isVerifiedCreator && (
            <div className="field row ">
              <label>Uid</label>
              <M.TextField
                fullWidth
                label="Uid"
                name="uid"
                value={$user.selected.uid || $user.selected._key}
                disabled
              />
            </div>
          )}
          {$user.sessionUser.isVerifiedCreator && (
            <div className="field row ">
              <label>CreatedOn</label>
              <M.TextField
                fullWidth
                label="createdOn"
                name="createdOn"
                value={$user.selected.createdOn || $user.selected.creationTime || ""}
                disabled
              />
            </div>
          )}
          {$user.sessionUser.isVerifiedCreator && (
            <div className="field row ">
              <label>creationTime</label>
              <M.TextField
                fullWidth
                label="creationTime"
                name="creationTime"
                value={$user.selected.creationTime || $user.selected.creationTime || ""}
                disabled
              />
            </div>
          )}
          {$user.sessionUser.isVerifiedCreator && (
            <div className="field row ">
              <label>LastSignInTime</label>
              <M.TextField
                fullWidth
                label="LastSignInTime"
                name="lastSignInTime"
                value={$user.selected.lastSignInTime || $user.selected.lastSignInTime || ""}
                disabled
              />
            </div>
          )}
          {$user.sessionUser.isVerifiedCreator && (
            <div className="field row">
              <label></label>
              <M.FormControlLabel
                checked={!$user.selected.disabled}
                onChange={(e, checked) => $user.selected.change("disabled", !e.target.checked)}
                control={<M.Checkbox name="disabled" />}
                label="Actief"
              />

              <M.FormControlLabel
                checked={$user.selected.emailVerified}
                onChange={(e, checked) => {
                  $user.selected.change("emailVerified", e.target.checked);
                }}
                control={<M.Checkbox name="emailVerified" />}
                label="Email bevestigd"
              />
            </div>
          )}

          {$user.sessionUser.isVerifiedCreator && (
            <div className="field row ">
              <label>E-mail</label>
              <M.TextField
                onChange={$user.selected.changeAndValidate}
                label="E-mail"
                name="email"
                fullWidth
                value={$user.selected.email || ""}
                required
                type="email"
              />
            </div>
          )}

          {$router.mode === "new" && (
            <div className="field row ">
              <label>Wachtwoord</label>
              <M.TextField
                label="Wachtwoord"
                name="password"
                value={$user.selected.password}
                autocomplete="off"
                className="mb-4 row"
                minLength="6"
                pattern=".{6,}"
                required
                type="password"
                validation={{
                  label: $validation.getValidationKey("password", "user-edit")
                }}
                onChange={$user.selected.changeAndValidate}
              />
            </div>
          )}

          {$user.sessionUser.isVerifiedCreator && (
            <div className="field row mb-4">
              <label>Rollen</label>
              <div className="flex flex-col w-full">
                {$user.selected.roles &&
                  $user.selected.roles.map((role, i) => (
                    <div className="flex" key={"role" + i}>
                      <M.TextField
                        className={"mb1 bg-gray-lightest w-full mr1"}
                        required
                        name={"role" + i}
                        value={role}
                        disabled
                        handleRef={input => {
                          if (
                            $user.selected &&
                            $user.selected.roles &&
                            i === $user.selected.roles.length - 1
                          )
                            this.latestRowRef = input;
                        }}
                        onChange={e => {
                          let roles = JSON.parse(JSON.stringify($user.selected.roles));
                          roles[i] = e.target.value;
                          $user.selected.change("roles", roles);
                        }}
                      />
                      <M.IconButton
                        icon={<Icon.Trash />}
                        className="bg-red"
                        onClick={() => {
                          let roles = JSON.parse(JSON.stringify($user.selected.roles));
                          roles.splice(i);
                          $user.selected.change("roles", roles);
                        }}
                      />
                    </div>
                  ))}
                <M.TextField
                  placeholder="Type een rol (creator, mentor, auth) en druk op enter"
                  name="addRow"
                  fullWidth
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      let roles = JSON.parse(JSON.stringify($user.selected.roles));
                      roles.push(e.target.value);
                      $user.selected.change("roles", roles);
                      e.target.value = "";
                    }
                  }}
                />
              </div>
            </div>
          )}

          <div key={"prop"} className="field row mb-4">
            <label>Groepen</label>
            <div className="flex flex-col w-full">
              {$user.sessionUser.isVerifiedCreator &&
                $user.selected.groupsArr &&
                $user.selected.groupsArr.map((group, i) => (
                  <div className="flex" key={"group" + i}>
                    <M.TextField
                      fullWidth
                      required
                      name={"group" + i}
                      value={group._key}
                      disabled
                      handleRef={input => {
                        if (
                          $user.selected &&
                          $user.selected.groups &&
                          i === $user.selected.groups.length - 1
                        )
                          this.latestRowRef = input;
                      }}
                      description={group.name}
                      onChange={e => {
                        let groups = JSON.parse(JSON.stringify($user.selected.groups));
                        groups[i] = e.target.value;
                        $user.selected.change("groups", groups);
                      }}
                    />
                    {$user.sessionUser.isVerifiedCreator && (
                      <M.Button
                        startIcon={<Icon.Trash />}
                        onClick={() => {
                          let groups = JSON.parse(JSON.stringify($user.selected.groups));
                          groups.splice(i);
                          $user.selected.change("groups", groups);
                        }}
                      />
                    )}
                  </div>
                ))}
              {$user.sessionUser.isVerifiedCreator && (
                <M.TextField
                  placeholder="Plak key/id van group, druk op enter en bewaar"
                  name="addRow"
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      $user.selected.addGroup(e.target.value);
                      e.target.value = "";
                    }
                  }}
                />
              )}
              {!$user.sessionUser.isVerifiedCreator &&
                $user.selected.groupsArr &&
                $user.selected.groupsArr.map((group, i) => (
                  <div className="flex" key={"group" + i}>
                    {group.name}
                  </div>
                ))}
            </div>
          </div>
          {!$user.sessionUser.isVerifiedCreator && (
            <i>Contacteer {$config.email} om extra groepen aan je account toe te voegen.</i>
          )}
          {true === false && (
            <M.Input
              label="Clusters"
              name="clusters"
              value={$user.selected.clusters}
              className="mb-4 row"
              type="text"
              description="Groep van enquête(s) waar deze gebruiker toegang tot heeft."
            />
          )}
        </form>
      )
    );
  }
};

export default inject("store")(observer(UserEdit));
